import React, { Component } from 'react'
import './style.css'
import Download from '../../assets/image/Download.svg'
import {TextField,Button,CircularProgress,FormControl,InputLabel,OutlinedInput} from '@material-ui/core'
import Modal from '../modal'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import axios from 'axios'
import {URL,USER,PASS} from '../../service/base_url'
import {get} from 'lodash'
export default class whitepaper extends Component {
    state={
        request_form:false,
        success_form:false,
        photoIndex: 0,
        isOpen: false,
        title:'',
        name:'',
        phoneNumber:'',
        email:'',
        companyName:'',
        loading:false
    }
    toggleRequest=(title)=>{
        this.setState({request_form:!this.state.request_form,title:title})
    }
    toggleSucces=()=>{
        this.setState({success_form:!this.state.success_form})
    }
    sendForm=()=>{
        this.setState({request_form:false,success_form:true})
    }
    onChange=(e)=>{
        e.preventDefault()
        this.setState({[e.target.name]:e.target.value})
    }
    submit=(e)=>{
        e.preventDefault()
        this.setState({loading:true})
        let {name,phoneNumber,email,companyName,title}=this.state
        axios.post(`${URL}`,{
            name,phoneNumber,email,companyName,action:`whitepaper-${title}`
        },{
            auth: {
                username: USER,
                password: PASS
              }
        }).then((res)=>{
            if(get(res,'status')==200){
                this.setState({loading:false})

                this.setState({success_form:!this.state.success_form,request_form:!this.state.request_form})
            }else{
                this.setState({loading:false})
                alert('Ops something error')
            }
        })
    }
    children=()=>{
        let {loading}=this.state
        return(
            <div>
                <p>Please fill out the form below to request a copy of brochure</p>
                <br/>
                <form onSubmit={this.submit}>
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="name">Name<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="name"
                        type='text'
                        name='name'
                        onChange={this.onChange}
                        required
                        labelWidth={70}
                    />
                </FormControl>
                <br/><br/>
               
                 <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="email">Email<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="email"
                        type='email'
                        name='email'
                        onChange={this.onChange}
                        required
                        labelWidth={70}
                    />
                </FormControl>
                <br/><br/>
               
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="phoneNumber">Handphone No.<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="phoneNumber"
                        type='number'
                        name='phoneNumber'
                        onChange={this.onChange}
                        required
                        labelWidth={120}
                    />
                </FormControl>
                <br/><br/>
                
                <FormControl variant="outlined" size="small"  className='form-request'>
                    <InputLabel  htmlFor="companyName">Company name<span style={{color:'red'}}>*</span></InputLabel>
                    <OutlinedInput
                        
                        id="companyName"
                        type='companyName'
                        name='companyName'
                        onChange={this.onChange}
                        required
                        labelWidth={120}
                    />
                </FormControl>
                
                
                <br/><br/>
                <Button type='submit' style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">
                    {loading? <CircularProgress size={20} style={{color:'white'}}/>:'Send'}
                </Button>
                </form>
            </div>
        )
    }
    children2=()=>{
        return(
            <div>
                <p>Thank you for your interest in One GML. we will contact you as soon as possible</p>
                <br/>
                <Button onClick={this.toggleSucces} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Ok</Button>
            </div>
        )
    }
    lightBoxToggle=(i)=>{
        this.setState({photoIndex:i,isOpen:!this.state.isOpen})
    }
    renderButtonRequest=(title)=>{
        return(
            <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:350}}>
                <Button onClick={()=>this.toggleRequest(title)} style={{textTransform:'none',width:100}} size="small" color="primary" variant="contained">Request</Button>
            </div>
        )
    }
    render() {
    const {data}=this.props
    const {request_form,success_form,photoIndex, isOpen }=this.state

        return (
            <div> 
                <Modal title="Download whitepaper" isOpen={request_form} children={this.children()} modalToggle={this.toggleRequest}/>
                <Modal title="Request whitepaper recorded" isOpen={success_form} children={this.children2()} modalToggle={this.toggleSucces}/>
                <div className='whitepaper-grid'>
                        {data.map((data,i)=>(
                            <div className='whitepaper-overlay'>
                                <img src={data.img}/>
                                <div className='request-copy'onClick={()=>this.toggleRequest(data.title)}>
                                    <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    <img src={Download} style={{width:15}}/>
                                    &nbsp;&nbsp;
                                    <p>request copy</p>
                                    </div>
                                </div>
                                <div className='request-copy show-mobile'onClick={()=>this.lightBoxToggle(i)}>
                                    <div style={{marginTop:'50%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    <img src={Download} style={{width:15}}/>
                                    &nbsp;&nbsp;
                                    <p>request copy</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
                {isOpen && (
                    <Lightbox
                        mainSrc={data[photoIndex].img}
                        imageCaption={this.renderButtonRequest(data[photoIndex].title)}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + data.length - 1) % data.length,
                        })
                        }
                        onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % data.length,
                        })
                        }
                    />
                )}
            </div>
        )
    }
}
